import React from 'react';
import {connect} from "react-redux";

const formatMB = (bytes) => {
  const places = 2;
  return `${(new Number((bytes/(1024*1024)).toFixed(places))).toLocaleString()}MB`;
}

const DetailCoupons = ({couponHistory}) => {
    return <div className="card mt-2 border-primary">
        <div className="card-body">
            <table className="table table-sm">
                <thead>
                <tr>
                    <th scope="col">日付</th>
                    <th scope="col">追加データ量</th>
                </tr>
                </thead>
                <tbody>
                {couponHistory.coupons.map(c => {
                    return <tr>
                        <td>{c.date}</td>
                        <td>{c.volume}MB</td>
                    </tr>
                })}
                {couponHistory.coupons.length===0 && <tr><td colspan="2" className="text-center"></td></tr>}
                </tbody>
            </table>
        </div>
    </div>;
};

const DetailDailyLogs = ({dailyLogs}) => {

    return <table className="table table-sm">
        <thead>
        <tr>
            <th scope="col" style={{width: '50%'}}>日付</th>
            <th scope="col" style={{width: '25%'}}>上り</th>
            <th scope="col" style={{width: '25%'}}>下り</th>
        </tr>
        </thead>
        <tbody>
        {dailyLogs.map(log => {
            return <tr>
                <td>{log.date}</td>
                <td>{log.uplinkBytes.toLocaleString()}</td>
                <td>{log.downlinkBytes.toLocaleString()}</td>
            </tr>
        })
        }
        </tbody>
    </table>;
}

const DetailPacketLogs = ({packetLogs}) => {

    return <div id="packetlogs-accordion">
        {[...packetLogs.months].reverse().map((m, idx) => {
            return <div className="card mt-2">
                <div className="card-header" id={`packetlogs-header-${idx}`}>
                    <a className="nav nav-link" data-toggle="collapse" data-target={`#packetlogs-collapse-${idx}`} aria-expanded="true"
                       aria-controls={`packetlogs-collapse-${idx}`}>
                        <div className="row">
                            <div className="col-6">{m.month.date}</div>
                            <div className="col-3">上り: {formatMB(m.month.uplinkBytes)}</div>
                            <div className="col-3">下り: {formatMB(m.month.downlinkBytes)}</div>
                        </div>
                    </a>
                </div>
                <div id={`packetlogs-collapse-${idx}`} className="collapse" aria-labelledby={`packetlogs-header-${idx}`}
                     data-parent="#packetlogs-accordion">
                    <div className="card-body">
                        <DetailDailyLogs dailyLogs={[...m.days].reverse()}/>
                    </div>
                </div>
            </div>
        })}
    </div>;
}

const Detail = ({global}) => {

    return global.packetLogs != null
        ? <DetailPacketLogs packetLogs={global.packetLogs}/>
        : global.couponHistory != null
            ? <DetailCoupons couponHistory={global.couponHistory}/>
            : null;
}


const mapState = state => ({
    global: state.global
});

const mapDispatch = dispatch => ({});

export default connect(mapState, mapDispatch)(Detail);
